import { createIcon } from '@chakra-ui/react';

export const SortUpArrowIcon = createIcon({
  displayName: 'SortUpArrowIcon',
  viewBox: '0 0 16 16',
  // path can also be an array of elements, if you have multiple paths, lines, shapes, etc.
  path: (
    <>
      <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M10.9475 9.68148L10.9476 9.68135C10.979 9.64997 11.0215 9.63233 11.0659 9.63232C11.1102 9.6323 11.1528 9.64991 11.1842 9.68127C11.2155 9.71263 11.2332 9.75517 11.2332 9.79953C11.2332 9.84389 11.2156 9.88645 11.1842 9.91783L8.31776 12.7843C8.2865 12.8156 8.24412 12.8331 8.19992 12.8331C8.15573 12.8331 8.11334 12.8156 8.08209 12.7843L5.21573 9.91795C5.2157 9.91792 5.21567 9.9179 5.21564 9.91787C5.1843 9.88644 5.16672 9.84386 5.16675 9.79947C5.16678 9.75504 5.18446 9.71245 5.21589 9.68106C5.24733 9.64967 5.28995 9.63205 5.33438 9.63208C5.3788 9.63211 5.4214 9.64979 5.45279 9.68123L5.45299 9.68143L7.84632 12.0754L8.19987 12.4291L8.55348 12.0755L10.9475 9.68148Z'
          fill='#ADADAD'
          stroke='#ADADAD'
        />
        <path
          d='M10.9475 6.31828L10.9476 6.31841C10.979 6.34979 11.0215 6.36742 11.0659 6.36744C11.1102 6.36746 11.1528 6.34985 11.1842 6.31849C11.2155 6.28713 11.2332 6.24459 11.2332 6.20023C11.2332 6.15586 11.2156 6.11331 11.1842 6.08193L8.31776 3.21544C8.31774 3.21542 8.31772 3.2154 8.3177 3.21539C8.28645 3.18417 8.24409 3.16664 8.19992 3.16664C8.15576 3.16664 8.11339 3.18417 8.08214 3.21539C8.08213 3.2154 8.08211 3.21542 8.08209 3.21544L5.21573 6.0818C5.21569 6.08184 5.21566 6.08187 5.21562 6.08191C5.1843 6.11333 5.16672 6.15591 5.16675 6.20029C5.16678 6.24471 5.18446 6.2873 5.21589 6.3187C5.24733 6.35009 5.28995 6.36771 5.33438 6.36768C5.3788 6.36764 5.4214 6.34997 5.45279 6.31853L5.45299 6.31833L7.84632 3.92433L8.19987 3.57068L8.55348 3.92428L10.9475 6.31828Z'
          fill='#3A81C5'
          stroke='#3A81C5'
        />
      </svg>
    </>
  ),
});
